export default "/fonts/vendor/remixicon/remixicon.woff2?90668f6f9b3c2c18a090f132d1793c67";